export const getSquadName = (squad) => {
  const squadName = squad && squad.replace(/^squad\:/, '');
  return squadName;
};
